module.exports = __webpack_public_path__ + "static/img/logo_transferh.8310650.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_transferh.png
// module id = 78
// module chunks = 0